export default __webpack_public_path__ + "static/media/tip_dragdrop_tracks@2x.bdb06c56.png";